import type { PersonId } from '@fs/zion-tree-types'
import { type ComponentProps } from 'react'
import type OrdinancePersonView from '@fs/zion-person-ordinance-view'
import { useSwrRequest } from './useSwrRequest'

export type PrimaryParents = NonNullable<ComponentProps<typeof OrdinancePersonView>['primaryParents']>

export default function usePrimaryParents(personId?: PersonId): PrimaryParents | undefined {
  const { data: parentsIds } = useSwrRequest<PrimaryParents[]>(
    personId ? `/service/tree/tree-data/v8/person/${personId}/parents-ids` : null
  )

  if (!parentsIds) return undefined

  let preferredFamily = parentsIds.find(
    ({ preferred, parent1Id, parent2Id }) =>
      preferred && parent1Id && parent1Id !== 'UNKNOWN' && parent2Id && parent2Id !== 'UNKNOWN'
  )

  // If we don't have a preferred family that has both parents, then we'll just use the first one we find.
  if (!preferredFamily) {
    preferredFamily = parentsIds.find(
      ({ parent1Id, parent2Id }) => parent1Id && parent1Id !== 'UNKNOWN' && parent2Id && parent2Id !== 'UNKNOWN'
    )
  }

  return preferredFamily
}
